import React from "react";
import { Check } from "lucide-react";

// Compact toggle button used inside content cards and group headers to
// flip in_progress/edited/published flags. Tones: "yellow" (edited),
// "ink" (published), "blue" (in_progress).
export function MiniToggle({
  checked,
  onClick,
  loading,
  tone,
  icon,
  title,
  testId,
  label,
}) {
  const active =
    tone === "ink"
      ? "bg-[var(--mp-ink)] text-white border-[var(--mp-ink)]"
      : tone === "blue"
      ? "bg-[#0984E3] text-white border-[#0984E3]"
      : "bg-[var(--mp-yellow)] text-[var(--mp-ink)] border-[var(--mp-ink)]";
  const idle =
    "bg-white text-[var(--mp-muted)] border-[var(--mp-border)] hover:text-[var(--mp-ink)] hover:border-[var(--mp-ink)]";
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      data-testid={testId}
      title={title}
      className={`flex-1 h-7 px-2 rounded-full border inline-flex items-center justify-center gap-1 transition-colors disabled:opacity-60 text-[11px] font-medium whitespace-nowrap ${
        checked ? active : idle
      }`}
    >
      {icon}
      {label && <span>{label}</span>}
      {checked && <Check className="h-2.5 w-2.5 ml-0.5" strokeWidth={3} />}
    </button>
  );
}
